import React, { useState, useCallback } from 'react';
import { Table } from 'udesk-ui';
import { useLiveEffect, useRequest } from 'src/util/hook';
import { inspect, isDefined } from 'src/util/core';
import './index.scss';
import UdeskLocales from 'UdeskLocales';

type PropsType = {
    scenario?: number;
    data: any[];
    setData: Function;
    selectedRowKey: number;
    setSelectedRowKey: (key: number | ((key: number) => number)) => void;
    sdkOptions: any;
    history: any;
    locales: any;
}

export default React.memo((props: PropsType) => {
    const {
        scenario = 2,
        data,
        setData,
        selectedRowKey, 
        setSelectedRowKey, 
    }= props;
    const [loading, setLoading] = useState(false);
    const request = useRequest();
    
    const renderCell = useCallback((text, record) => {
        return (
            <div className='table-row-item' onClick={() => setSelectedRowKey(record.key)}>
                <span>{record.name}</span>
            </div>
        );
    }, [setSelectedRowKey]);

    useLiveEffect((success) => {
        setLoading(true);
        const url = `/review/words/favorite/${scenario}`;
        request(url, {
            pageNum: 1,
            pageSize: 99999,
        }).then(({data}) => {
            success(() => {
                setData(data.map(item => {
                    return {
                        ...item, key: item.clusterId
                    };
                }));
                inspect(data.length > 0 && !isDefined(selectedRowKey), () => {
                    setSelectedRowKey(data[0].clusterId);
                });
            });
        }).finally(() => {
            setLoading(false);
        });
    }, [scenario]);

    return (
        <div className='words-mining-favorite-page-left selling-point'>
            <Table
                loading={loading}
                scroll={{
                    y: '100%'
                }}
                rowSelection={{
                    selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
                    columnTitle: <div className='column-header'>{/* 产品卖点话术库 */}{UdeskLocales['current'].pages.semanticIntelligence.wordsMining.favoriteView.sellingPoint.components.pageLeftTable.productSellingPointScriptLibrary}</div>,
                    type: 'radio',
                    renderCell,
                }}
                pagination={{
                    pageSize: 99999,
                    total: data.length,
                    hideOnSinglePage: true,
                }} 
                columns={[]}
                dataSource={data}
            />
        </div>
    );
});
